﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";
import Select from "react-select";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { toast, validRoles } from "@/services/Utils";
import api from "@/services/api.service";

import { base_balance } from "../balances.constants";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const BalancesForm = ({ confirmSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, balance_id } = useParams();
	const navigate = useNavigate();

	const { customers, estates, estates_parents, status } = useSelector((state) => state.maintainers_balances);

	const [isFetching, setIsFetching] = useState(true);
	const [data, setData] = useState({ ...base_balance });

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/balanzas");
	};

	const validSave = () => {
		if (!data.customer_id) {
			toast(addToast, "Debe seleccionar un cliente para guardar.", "error");
			return false;
		}

		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre a la balanza para guardar.", "error");
			return false;
		}

		if (!data.status_id) {
			toast(addToast, "Debe seleccionar un estado para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave({ form: data }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_balance });
	};

	const afterSave = () => {
		handleClose();
		addToast("Balanza guardado correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && balance_id) {
			api.get("/admin/balances/detail", { selected: balance_id }).then((response) => {
				const { detail } = response;
				if (detail) {
					setData(detail);
				} else {
					addToast("Ocurrió un problema al cargar la balanza seleccionada.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [balance_id, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Balanza</h4>
			</Modal.Header>
			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Cliente</Form.Label>
								<Select
									value={customers && customers.filter((c) => Number(c.value) === Number(data.customer_id))}
									placeholder={<div>Seleccione</div>}
									options={customers ? customers : []}
									onChange={(value) =>
										setData({
											...data,
											customer_id: value ? value.value : "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Campo</Form.Label>
								<Select
									value={
										estates_parents &&
										estates_parents.filter(
											(c) =>
												Number(c.customer_id) === Number(data.customer_id) &&
												data.estates_parents &&
												data.estates_parents.includes(String(c.value)),
										)
									}
									placeholder={<div>Seleccione</div>}
									options={estates_parents ? estates_parents.filter((e) => Number(e.customer_id) === Number(data.customer_id)) : []}
									onChange={(value) =>
										setData({
											...data,
											estates_parents: value ? value.map((v) => v.value).join(",") : "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isMulti
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Bodega</Form.Label>
								<Select
									value={
										estates &&
										estates.filter(
											(c) => Number(c.customer_id) === Number(data.customer_id) && data.estates && data.estates.includes(String(c.value)),
										)
									}
									placeholder={<div>Seleccione</div>}
									options={
										estates
											? data.estates_parents
												? estates.filter(
														(e) =>
															Number(e.customer_id) === Number(data.customer_id) &&
															data.estates_parents.includes(String(e.estate_parent_id)),
													)
												: estates.filter((e) => Number(e.customer_id) === Number(data.customer_id))
											: []
									}
									onChange={(value) =>
										setData({
											...data,
											estates: value ? value.map((v) => v.value).join(",") : "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isMulti
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control
									value={data.name ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>AnyDesk</Form.Label>

								<Form.Control
									value={data.anydesk_id ? data.anydesk_id : ""}
									onChange={(e) =>
										setData({
											...data,
											anydesk_id: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Ubicación</Form.Label>

								<Form.Control
									value={data.location ? data.location : ""}
									onChange={(e) =>
										setData({
											...data,
											location: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Estado</Form.Label>
								<Select
									value={status && status.filter((c) => Number(c.value) === Number(data.status_id))}
									placeholder={<div>Seleccione</div>}
									options={status ? status : []}
									onChange={(value) =>
										setData({
											...data,
											status_id: value ? value.value : "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default BalancesForm;
